import { render, staticRenderFns } from "./grantLoaningNew.vue?vue&type=template&id=578f67a0&scoped=true"
import script from "./grantLoaningNew.vue?vue&type=script&lang=js"
export * from "./grantLoaningNew.vue?vue&type=script&lang=js"
import style0 from "./grantLoaningNew.vue?vue&type=style&index=0&id=578f67a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578f67a0",
  null
  
)

export default component.exports